import { combineReducers } from 'redux';
import loginData from './loginReducer';
import channelData from './channelReducer';
import episodeData from './episodeReducer';
import bibleData from './bibleReducer';
import languageData from './languageReducer';
import readingPlanData from './readingPlanReducer';
import readingData from './readingReducer';
import userData from './userReducer';
import messageBoardData from './messageBoardReducer';
import orderData from './orderReducer';
import donationData from './donationReducer';
import azureData from './azureReducer';
import videoHotlineData from './videoHotlineReducer';
import testimonialData from './testimonialReducer';
import promiseLandData from './promiseLandReducer';
import settingData from './settingReducer';
import dabFilmsData from './dabFilmsReducer';
import musicsData from './musicsReducer';
import prayerData from './prayerAndTalksReducer';
import musicPlatformData from './musicsPlatformReducer';
import manageCategoryData from './manageCategoryReducer';
import videoHotlineCategoryData from './videoHotlineCategoryReducer';
import resourceData from './resourceReducer';
import releaseNotificationData from './releaseNotificationReducer';
import ratingData from './ratingReducer';

const reducers = combineReducers({
	azureData,
	loginData,
	channelData,
	episodeData,
	bibleData,
	languageData,
	readingPlanData,
	readingData,
	userData,
	messageBoardData,
	orderData,
	donationData,
	videoHotlineData,
	testimonialData,
	promiseLandData,
	settingData,
	dabFilmsData,
	musicsData,
	prayerData,
	musicPlatformData,
	manageCategoryData,
	videoHotlineCategoryData,
	resourceData,
	releaseNotificationData,
	ratingData
})

export default reducers;